export const LOGO = {
  LOGO: require("./logo.png"),
  BLACK: require("./logo-black1.png"),
};
export const IMG = {
  HERO: require("./smile.png"),
  MAN: require("./person.png"),
  // DOC1: require("./d1test.jpg"),
  DOC1: require("./DR1T.jpg"),
  // DOC2: require("./d2test.jpeg"),
  DOC2: require("./DR2T.jpg"),
  // DOC3: require("./d3test.jpg"),
  DOC3: require("./DR3T.jpg"),
  // DOC4: require("./d4test.jpg"),
  DOC4: require("./DR4T.jpg"),
  DOC5: require("./DR5T.jpg"),
  // DOCTOR1: require("./d1tests.jpg"),
  DOCTOR1: require("./DTR1T.jpg"),
  // DOCTOR2: require("./d2tests.jpeg"),
  DOCTOR2: require("./DTR2T.jpg"),
  // DOCTOR3: require("./d3tests.jpg"),
  DOCTOR3: require("./DTR3T.jpg"),
  // DOCTOR4: require("./d4tests.jpg"),
  DOCTOR4: require("./DTR4T.jpg"),
  DOCTOR5: require("./DTR5T.jpg"),

  // DOC1: require("./d1.jpg"),
  // DOC2: require("./d2.jpg"),
  // DOC3: require("./d3.jpg"),
  // DOC4: require("./d4.jpg"),
  // DOC1: require("./doc1testa.png"),
  // DOC2: require("./doc2.png"),
  // DOC3: require("./doc3.png"),
  // DOCTOR1: require("./doctortest1a.jpg"),
  // DOCTOR2: require("./doctor2a.jpg"),
  // DOCTOR3: require("./d3a.jpg"),
  ARO: require("./arrow.png"),
  LADY: require("./lady.png"),

  MAP: require("./world.png"),
  MOB: require("./phone.png"),
  MAIL: require("./mail.png"),
  TW: require("./x.png"),
  TWB: require("./xb.png"),
  INSF: require("./insf.png"),
  INSH: require("./insh.png"),
  YT: require("./yt.png"),
  YTB: require("./YTb.png"),
  IN: require("./in.png"),
  INB: require("./LinB.png"),
  FB: require("./fb.png"),
  FBB: require("./Fbb.png"),
  EDU: require("./edu.png"),
  MEM: require("./mem.png"),
  MINUS: require("./minus.png"),
  SQUARE: require("./square.png"),
  TREATMENT: require("./treatment.png"),
  INSURANCE: require("./insurance.png"),
  INSURANCE2: require("./insurance2.png"),
  // LOGO1: require("./banktest1.png"),
  LOGO1: require("./bankk.jpg"),
  LOGO2: require("./banktest2.jpeg"),
  LOGO3: require("./banktest3.png"),
  LOGO4: require("./banktest2.jpeg"),
  // LOGO1: require("./bank1o.png"),
  // LOGO2: require("./bank2c.png"),
  // LOGO3: require("./bank3o.png"),
  // LOGO4: require("./bank4o.png"),
  B1: require("./b1test.jpeg"),
  B2: require("./b2test.jpeg"),
  B3: require("./b3test.jpeg"),
  B4: require("./b4test.jpeg"),
  // B1: require("./b1.jpg"),
  // B2: require("./b2.jpg"),
  // B3: require("./b3.jpg"),
  // B4: require("./b4.png"),
};
export const WHY = {
  ONE: require("./why1n.png"),
  TWO: require("./why2n.png"),
  THR: require("./why3n.png"),
  FOU: require("./why4n.png"),
};
